module.exports = __webpack_public_path__ + "img/dypitch-1.293c5a02.jpg";